import {
    PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR,
} from '../constants';

export function clearBonificationTakingCar() {
    return (dispatch) => {
        dispatch({
            type: PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR
        })
    }
}